import React, { useContext, useState } from 'react'
import './Footer.css'
import { FiShoppingCart } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import cardContext from '../../context/cards/cardContext';
import CartBottomSheet from '../cart/CartBottomSheet';

const Footer = () => {
    const {getTotalQuantity} = useContext(cardContext)
    const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);
    const navigate = useNavigate();
    
    const openBottomSheet = () => {
        setIsBottomSheetOpen(true);
    }

    const closeBottomSheet = () => {
        setIsBottomSheetOpen(false);
    }

    const navigateToCart = (e) => {
        e.stopPropagation(); // Prevent footer click event
        navigate('/cart');
    }

    return (
        <>
            <footer className="sticky-footer" onClick={openBottomSheet}>
                <div className="footer-left">
                    <FiShoppingCart size={24} className="cart-icon" />
                </div>
                <div className="footer-center">
                    <span>{getTotalQuantity()} {getTotalQuantity() > 1 ? "Items" : "Item"}</span>
                </div>
                <button className="footer-cart-button" onClick={navigateToCart}>
                    Go to Cart
                </button>
            </footer>

            <CartBottomSheet 
                isOpen={isBottomSheetOpen} 
                onClose={closeBottomSheet} 
            />
        </>
    )
}

export default Footer
